<template>
    <div>
        <tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator" :has_popup_info="has_popup_info" :popup_info_title_html="popup_info_title_html" :popup_info_inner_html="popup_info_inner_html" :helper_text="helper_text">
        </tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionGlassDesign from "../DesignerQuestionGlassDesign.vue";

    export default {
        mixins: [
            DesignerQuestionGlassDesign
        ],
        props: {
            title: {
                default(){
                    return 'Select A Glass Design For Your Door';
                }
            },
        },
        computed: {
            panel_required(){
                return [142,143].includes(this.doorRange) || (Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1);
            }
        }
    }
</script>
